import React, { useState } from "react"
import { Col, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import SearchSelectBox from "../../../components/SearchSelectBox"
import { assignPriceComponent, getPriceComponents } from "../../../api/priceComponent"
import { useResponse } from "../../../hooks/useResponse"
import ResultHandler from "../../../components/ResultHandler"
import { getAdmins } from "../../../api/admins"

const AssignPriceComponentsModal = ({show, handleClose, handleRefetch, relatedId, type}) => {
    const { t } = useTranslation()

    const neededType = type == 'companies' ? "company" : "employee"

    const [compId, setCompId] = useState(null)
    const [amount, setAmount] = useState(null)
    const [admin, setAdmin] = useState(null)

    const {loading, error, setData} = useResponse(assignPriceComponent, () => {
        handleRefetch()
        handleClose()
    })

    function handleConfirm(){
      const data = {
        amount,
        priceComponentId: compId.value,
        admin_id: admin?.id || null,
        ...(type == 'companies'? {companyId: relatedId} : {employeeId: relatedId})
      }
      setData({type: "add", data })
    }

    return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center mb-4">
              <h3>Assign Price Component</h3>
            </div>
          </Col>
        </Row>
        <Row>
            <Col md={12}>
                <SearchSelectBox 
                    type="priceComponents"
                    label='name'
                    api={getPriceComponents}
                    apiMeta={{type: neededType}}
                    value={compId?.value || null}
                    setValue={e => {
                        setCompId(e)
                        setAmount(e?.amount)
                    }}
                /> 

                {compId && <FormGroup className="mt-3">
                    <Label>Amount ({compId.amount_type == 'percentage' ? '%' : 'E'})</Label>
                    <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
                </FormGroup>}

                {compId && <>
                  <Label>Admin</Label>
                  <SearchSelectBox 
                    type="admins"
                    api={getAdmins}
                    apiMeta={{type: neededType}}
                    label='username'
                    value={admin?.id || null}
                    setValue={e => {
                      setAdmin(e)
                    }}
                  />
                </>}

                <ResultHandler error={error} />
            </Col>
          <Col>
            <div className="text-center mt-4">
              {!loading && <button
                type="button"
                className="btn btn-primary btn-lg ms-2"
                onClick={handleConfirm}
              >
                Assign
              </button>}
              {loading && <button
                type="button"
                className="btn btn-dark btn-lg ms-2"
              >
                Wait
              </button>}
              <button
                type="button"
                className="btn btn-secondary btn-lg ms-2"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default AssignPriceComponentsModal
